import React from "react";
import {
	List,
	ListItem,
	ListSubheader,
	Button,
	IconButton,
	ListItemText,
	ListItemSecondaryAction,
} from "@material-ui/core";
import FormTextField from "../../../components/FormTextField/FormTextField";
import DeleteIcon from "@material-ui/icons/Delete";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";

const CallSubjectList = ({ subjectsList, updateSubjectHandler, addNewSubjectHandler }) => {
	const getNameErrorMessage = (value) => {
		if (!value) {
			return "Option name is required.";
		}
		if (value.length > 50) {
			return "option name cannot exceed 50 characters.";
		}
	};

	return (
		<List
			component="nav"
			subheader={
				<ListSubheader disableSticky component="div">
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							justifyContent: "space-between",
							alignItems: "center",
						}}
					>
						<span>Call Options </span>
						<Button variant="outlined" size="small" onClick={addNewSubjectHandler}>
							Add Call Option
						</Button>
					</div>
				</ListSubheader>
			}
		>
			<div style={{ maxHeight: "250px", overflow: "auto" }}>
				{subjectsList.length > 0 ? (
					subjectsList.map((x, index) => (
						<ListItem key={x.subjectId}>
							<ListItemText>
								<FormTextField
									formEdited
									required
									errorMessage={getNameErrorMessage(x.subject)}
									startingValue={x.subject}
									setConfigValue={(value, val) => {
										let newSubjects = [...subjectsList];
										newSubjects[index].subject = val;
										updateSubjectHandler(newSubjects);
									}}
									valueName="subject"
									styleObject={{ minWidth: "85%", flex: 1 }}
									errorCheck={(val) => !val || val.length > 50}
								/>
							</ListItemText>
							<ListItemSecondaryAction>
								<IconButton
									aria-label="moveUp"
									title="Move Up"
									disabled={index === 0}
									onClick={() => {
										let tempSubjectList = [...subjectsList];
										var f = tempSubjectList.splice(index, 1)[0];
										tempSubjectList.splice(index - 1, 0, f);
										updateSubjectHandler(tempSubjectList);
									}}
								>
									<ArrowUpwardIcon />
								</IconButton>
								<IconButton
									aria-label="moveDown"
									title="Move Down"
									disabled={index === subjectsList.length - 1}
									onClick={() => {
										let tempSubjectList = [...subjectsList];
										var f = tempSubjectList.splice(index, 1)[0];
										tempSubjectList.splice(index + 1, 0, f);
										updateSubjectHandler(tempSubjectList);
									}}
								>
									<ArrowDownwardIcon />
								</IconButton>
								<IconButton
									aria-label="remove"
									title="Remove Option"
									style={{ color: "#cc1f20" }}
									onClick={() => {
										let newSubjects = subjectsList.filter((subject) => subject.subjectId !== x.subjectId);
										updateSubjectHandler(newSubjects);
									}}
								>
									<DeleteIcon />
								</IconButton>
							</ListItemSecondaryAction>
						</ListItem>
					))
				) : (
					<ListItem>
						<span className="text-danger font-italic">At least one call option is required.</span>
					</ListItem>
				)}
			</div>
		</List>
	);
};

export default CallSubjectList;
